<template>
  <Dialog :visible="show" @close="customClose" alert boxStyle="width:588px">
    <div class="mt-8 text-whitebase">
      <div class="font-bold text-xl mb-4">
        Notify Add
        <span class="font-normal">({{ item.name || item.address }})</span>
      </div>
      <div v-if="type === 'dao'">
        <div
          class="flex items-center justify-between text-sm font-bold py-3 px-4"
          v-for="(event, i) in [
            { label: 'Proposal Creation', value: 'D001' },
            { label: 'Proposal Conclusion', value: 'D002' },
            {
              label: 'Large Fund Transfer In (>50K USD)',
              value: 'D003',
            },
            {
              label: ' Large Fund Transfer Out (>50K USD)',
              value: 'D004',
            },
            {
              label: 'Treasury Asset Growth Exceeding 5%',
              value: 'D005',
            },
            {
              label: 'Treasury Asset Reduction Exceeding 5%',
              value: 'D006',
            },
          ]"
          :key="i"
        >
          <div>
            {{ event.label }}
          </div>
          <CustomToggle
            label-style="text-whitebase text-sm"
            class="text-sm"
            :bgColor="'bg-background'"
            :isChecked="item.events.includes(event.value)"
            @change="(x) => handleChange(x, event)"
          ></CustomToggle>
        </div>
      </div>
      <div v-if="type === 'member'">
        <div
          class="flex justify-between items-center text-sm font-bold py-3 px-4"
          v-for="(event, i) in [
            { label: 'Proposal Creation', value: 'U001' },
            { label: 'Proposal Voting', value: 'U002' },
          ]"
          :key="i"
        >
          <div>
            {{ event.label }}
          </div>
          <CustomToggle
            label-style="text-whitebase text-sm"
            class="text-sm"
            :bgColor="'bg-background'"
            :isChecked="item.events.includes(event.value)"
            @change="(x) => handleChange(x, event)"
          ></CustomToggle>
        </div>
      </div>
      <div class="flex justify-end mt-6">
        <div class="flex gap-4">
          <UiButton
            @click="handleClose"
            type="main-weak"
            class="mr-4 w-28"
            size="sm"
            >CANCEL</UiButton
          >
          <UiButton
            class="w-28"
            size="sm"
            @click="handleSave(item)"
            :disabled="canSubmit"
            >SAVE</UiButton
          >
          <!-- <div
            style="width: 120px; height: 32px"
            class="
              rounded-lg
              border border-whitebase
              flex
              items-center
              justify-center
              cursor-pointer
            "
            @click="handleClose"
          >
            CANCEL
          </div>
          <div
            @click="eventsUpdate(item.notifyId, state.events)"
            style="width: 120px; height: 32px"
            class="
              cursor-pointer
              bg-inputActive
              rounded-lg
              flex
              items-center
              justify-center
            "
          >
            SAVE
          </div> -->
        </div>
      </div>
    </div>
  </Dialog>
</template>
<script setup>
import Dialog from '@/components/Dialog.vue';
import CustomToggle from '@/components/Inputs/CustomToggle.vue';
import { onMounted, reactive, watch } from 'vue';
import { eventsUpdate } from '@/api/dao';
import UiButton from '@/components/UiButton.vue';
import { notify } from '@kyvg/vue3-notification';

const props = defineProps({
  show: Boolean,
  handleClose: Function,
  type: String,
  item: Object,
});
console.log('notif dialog', props);
const state = reactive({ events: [] });
const handleChange = (x, event) => {
  console.log(x, event, state.events, state.events.indexOf(event.value));
  if (x) state.events = [...state.events, event.value];
  else state.events.splice(state.events.indexOf(event.value), 1);
  console.log(x, event, state.events);
};
const customClose = () => {
  state.events = [];
  props.handleClose();
};
watch(
  () => props?.item?.events,
  () => (state.events = props.item.events),
);
onMounted(() => {
  state.events = props?.item?.events;
});
const handleSave = async (item) => {
  try {
    const res = await eventsUpdate(item.notifyId, state.events);
    notify({
      type: 'success',
      text: 'Notifcation settings updated.',
      duration: 5000,
    });
    customClose();
  } catch (e) {
    notify({
      type: 'error',
      text: e.message,
      duration: 5000,
    });
  }
};
</script>
<style></style>
